var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivesessionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2266 20.9266H8.12656C5.88635 20.9266 4.76625 20.9266 3.9106 20.505C3.15795 20.1342 2.54603 19.5425 2.16254 18.8148C1.72656 17.9875 1.72656 16.9044 1.72656 14.7384V7.77664C1.72656 5.61057 1.72656 4.52753 2.16254 3.7002C2.54603 2.97246 3.15795 2.38079 3.9106 2.00999C4.76625 1.58844 5.88635 1.58844 8.12656 1.58844L13.3266 1.58844C15.5668 1.58844 16.6869 1.58844 17.5425 2.00999C18.2952 2.38079 18.9071 2.97246 19.2906 3.7002C19.7266 4.52753 19.7266 5.61057 19.7266 7.77664V11.741",
    stroke: "#BBBBBB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7905 14.6686C14.7905 14.2134 14.7905 13.9858 14.8887 13.8604C14.9742 13.7511 15.1049 13.6834 15.2464 13.6753C15.4088 13.6659 15.6046 13.7921 15.9963 14.0446L21.0937 17.3304C21.4173 17.539 21.5791 17.6433 21.6355 17.7748C21.6848 17.8898 21.6848 18.0189 21.6355 18.1339C21.5791 18.2654 21.4173 18.3697 21.0937 18.5783L15.9963 21.8641C15.6046 22.1166 15.4088 22.2428 15.2464 22.2334C15.1049 22.2253 14.9742 22.1576 14.8887 22.0483C14.7905 21.9229 14.7905 21.6953 14.7905 21.2401V14.6686Z",
    stroke: "#BBBBBB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82861 7.90077H14.808",
    stroke: "#BBBBBB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82861 11.8821H12.2489",
    stroke: "#BBBBBB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82764 15.5452H9.58688",
    stroke: "#BBBBBB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivesessionIcon);
export default __webpack_public_path__ + "static/media/livesession_icon.72ac62353a1f589b0fed44941b1b8b26.svg";
export { ForwardRef as ReactComponent };